export enum ActionType {
  Create,
  Update,
}

export const getActionText = (action: ActionType) =>
  action === ActionType.Update ? '更新' : '导入'
